import React, { Component } from 'react';
import Header from './App/component/Header';
import ListApp from './App/component/ListApp';
import logo from './logo.svg';
import './App/logic/spotIt.js';

function App() {
  return (
      <div>
        <Header />
        <ListApp />
      </div>
  );
}

export default App;
